import { type ArtistT, getId, useGlobalStateObject } from 'utils';

/** For the given artist record it looks up whether artist records with the same
 *  ID are present in a few global state segments where artist records are stored,
 *  and where they are present it replaces those records with the given one. */
export default function useSetArtist(): (artist: ArtistT) => void {
  const gs = useGlobalStateObject();

  return (artist: ArtistT) => {
    const artistId = getId(artist);

    const listIdx = gs.get('artists.list.data.items')
      ?.findIndex((item) => item.id === artistId);

    if (listIdx !== undefined && listIdx >= 0) {
      gs.set(`artists.list.data.items.${listIdx}`, artist);
    }

    const mapPath = `artists.map.${artistId}.data` as const;
    if (gs.get(mapPath)) gs.set(mapPath, artist);

    if (gs.get('userArtist.data.id') === artistId) {
      gs.set('userArtist.data', artist);
    }
  };
}
